export default __webpack_public_path__ + "static/media/react-logo.542d361c.png";